<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="sourcingSubmitHeadInfo" label-width="140px">
          <el-row>
            <el-button @click="sourcingSubmit" v-acl="SourcingSubmit" type="primary">提交</el-button>
            <el-button type="primary" @click="goBack">{{$t('common.close')}}</el-button>
            <!--关闭-->
          </el-row>
          <el-row :gutter="24" style="margin-top:20px">
            <el-col :span="6">
              <el-form-item :label="$t('quoteByLine.sourcing.sourcingNo')" prop="sourcingNo">
                <el-input class="handle-input" v-model="sourcingSubmitHeadInfo.sourcingNo" clearable disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('quoteByLine.sourcing.subject')" prop="subject">
                <el-input class="handle-input" v-model="sourcingSubmitHeadInfo.subject" clearable disabled></el-input>
              </el-form-item>

            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('quoteByLine.sourcing.applyType')" prop="applyType">
                <el-input class="handle-input" v-model="sourcingSubmitHeadInfo.applyTypeI18n" clearable disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="6">
              <el-form-item :label="$t('quoteByLine.sourcing.quotationType')" prop="quotationType">
                <el-input class="handle-input" v-model="sourcingSubmitHeadInfo.quotationTypeI18n" clearable disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('common.createBy')" prop="userName">
                <el-input class="handle-input" v-model="sourcingSubmitHeadInfo.userName" clearable disabled></el-input>
              </el-form-item>

            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('common.createDate')" prop="applyCcreateDate">
                <el-input class="handle-input" v-model="sourcingSubmitHeadInfo.applyCreateDate" clearable disabled>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="6">
              <el-form-item :label="$t('quoteByLine.sourcing.supplierCode')" prop="supplierCodes">
                <el-input class="handle-input" v-model="sourcingSubmitHeadInfo.supplierCodes" clearable disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('quoteByLine.sourcing.applyNo')" prop="applyNo">
                <el-input class="handle-input" v-model="sourcingSubmitHeadInfo.applyNo" clearable disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <ux-grid ref="sourcingSubmitDialogData" :data="sourcingSubmitDialogData" keep-source max-height="550" @selection-change="selectionChange" highlight-current-row :row-class-name="rowClassName" show-overflow="tooltip">
          <ux-table-column align="center" type="checkbox" width="80" />
          <ux-table-column align="center" title="序号" type="index" width="60"></ux-table-column>
          <ux-table-column align="center" sortable resizable :title="$t('quoteByLine.sourcing.finalSupplier')" field="supplierName" min-width="200"></ux-table-column>
          <ux-table-column align="center" sortable resizable :title="$t('quoteByLine.sourcing.pickupPoint')" field="pickupPoint" min-width="180"></ux-table-column>
          <ux-table-column align="center" sortable resizable :title="$t('quoteByLine.sourcing.dc')" field="dcName" min-width="200"></ux-table-column>
          <ux-table-column align="center" sortable resizable :title="$t('quoteByLine.sourcing.temperature')" field="temperatureI18n" min-width="100"></ux-table-column>
          <ux-table-column align="center" sortable resizable :title="$t('quoteByLine.sourcing.transportaionMethod')" field="transportaionMethodI18n" min-width="100"></ux-table-column>
          <ux-table-column align="center" sortable resizable :title="$t('quoteByLine.sourcing.unit')" field="unitI18n" min-width="100"></ux-table-column>
          <ux-table-column align="center" sortable resizable :title="$t('quoteByLine.sourcing.effectiveBeginDate')" field="effectiveBeginDate" min-width="140">
            <template v-slot="scope">
              {{scope.row.effectiveBeginDate | dateFormatFilter("YYYY-MM-DD")}}
            </template>
          </ux-table-column>
          <ux-table-column align="center" sortable resizable :title="$t('quoteByLine.sourcing.price')" field="price" min-width="140"></ux-table-column>
          <ux-table-column align="center" sortable resizable :title="$t('quoteByLine.sourcing.currentSupplier')" field="supplierName" min-width="160"></ux-table-column>
          <ux-table-column align="center" sortable resizable :title="$t('quoteByLine.sourcing.currentPrice')" field="formalPrice" min-width="160"></ux-table-column>
          <ux-table-column align="center" sortable resizable :title="$t('quoteByLine.sourcing.currencyCode')" field="currencyCode" min-width="100"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="Leadtime" field="leadTime" min-width="100"></ux-table-column>
          <ux-table-column align="center" sortable resizable title="线路类型" field="lineTypeI18n" min-width="100"></ux-table-column>
          <ux-table-column align="center" sortable resizable :title="$t('quoteByLine.sourcing.remarks')" field="remarks" min-width="100"></ux-table-column>
        </ux-grid>
      </div>
    </div>
  </div>
</template>

<script>
import { sourcingSubmit, querySubmitData } from "../../../api/line/sourcing";
import { Message } from "element-ui";
import router from '../../../router';
export default {
  name: 'sourcing-sel',
  data() {
    return {
      sourcingSubmitHeadInfo: {},
      sourcingSubmitDialogData: [],
      sourcingList: [],
      multipleSelection: []
    }
  },
  created() {
    this.getList(this.$route.query.ttQuotationId);
  },
  methods: {
    getList(ttQuotationId) {
      querySubmitData(ttQuotationId).then((res) => {
        this.sourcingList = res.resultData;
        this.querySourcingSubmitData()
        this.$refs.sourcingSubmitDialogData.reloadData(res.resultData)
      })
    },

    //查询报价确认提交数据
    querySourcingSubmitData() {
      this.sourcingSubmitDialogData = this.sourcingList;
      this.sourcingSubmitHeadInfo = this.sourcingSubmitDialogData[0];
      this.sourcingSubmitHeadInfo.applyCreateDate = this.sourcingSubmitDialogData[0].applyCreateDate.split(" ")[0];

    },
    // 选中的行
    selectionChange(row) {
      console.log(row)
      this.multipleSelection = row
    },
    //报价确认提交
    sourcingSubmit() {
      // let rows = this.$refs.sourcingSubmitDialogData.selection;
      console.log('rows', this.multipleSelection)
      let rows = this.multipleSelection
      if (rows.length == 0) {
        //Message({message: this.$t('base.pp.selectPickupPoint'), type: "warning"});
        Message({ message: this.$t('quoteByLine.sourcing.selSourcingData'), type: "warning" });
      } else {
        let applylineIds = [];
        rows.forEach((item) => {
          applylineIds.push(item.ttQuotationApplyLineId);
        });
        let ids = applylineIds.sort();

        for (let i = 0; i < ids.length - 1; i++) {
          if (ids[i] === ids[i + 1]) {
            Message({ message: this.$t('quoteByLine.sourcing.dataError'), type: "warning" });
            return;
          }
        }
        this.$confirm(this.$t('quoteByLine.sourcing.confirmSubmit'), this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(() => {
          sourcingSubmit(rows).then((res) => {
            if (res.meta.success) {
              Message({ message: this.$t('quoteByLine.sourcing.success'), type: "success" });

              router.replace({
                path: './sourcing'
              });
            } else {
              Message({ message: this.$t('quoteByLine.sourcing.fail'), type: "error" });
            }
          })

        })
      }
    },
    rowClassName({ row, rowIndex }) {
      return (this.sourcingSubmitDialogData.filter(tmpRow => {
        return tmpRow.ttQuotationApplyLineId == row.ttQuotationApplyLineId
          && tmpRow.price - row.price < 0
      }).length == 0) ? "success-row-q" : "";
    },
    goBack() {
      window.history.go(-1);
    }
  }
}

</script>
<style scoped>
.handle-input {
  width: 95%;
}
.query-btn-row {
  width: 30%;
  float: right;
}
.action-btn-row {
  margin-bottom: 10px;
  margin-top: 10px;
}
.dialog-input {
  width: 40%;
}
.el-table .success-row-q {
  background: #ffa796 !important;
}
</style>
